import { Controller } from "@hotwired/stimulus"
import "./task_component.css"

export default class extends Controller {
  static targets = ["form", "statusField", "newTaskForm", "titleField"]
  static values = {
    focus: Boolean,
    editUrl: String
  }

  connect() {
    if (this.focusValue && this.hasTitleFieldTarget) {
      requestAnimationFrame(() => {
        const input = this.titleFieldTarget
        input.focus()
        input.select()
        this.focusValue = false // optional: avoid refocusing on reconnect
      })
    }
  }

  toggle(event) {
    event.preventDefault()

    if (this.currentStatus == "in_progress" || this.currentStatus == "todo") {
      this.updateStatus("completed")
    } else if (this.currentStatus == "completed") {
      this.updateStatus("todo")
    }
  }

  inProgress(event) {
    event.preventDefault()

    this.updateStatus("in_progress")
  }

  todo(event) {
    event.preventDefault()

    this.updateStatus("todo")
  }

  updateStatus(status) {
    this.statusFieldTarget.value = status
    this.formTarget.requestSubmit()
  }

  insertAfter(event) {
    event.preventDefault()
    event.stopPropagation()

    this.newTaskFormTarget.requestSubmit()
  }

  cancel(event) {
    event.preventDefault()
    event.stopPropagation()

    // Flash red
    const contentDiv = this.element.querySelector(".task-content")
    contentDiv.classList.add("flash-red")

    // Find next task to focus on
    const nextTask = this.element.nextElementSibling
    const prevTask = this.element.previousElementSibling
    const taskToFocus = nextTask || prevTask

    // Remove from DOM and focus after animation
    setTimeout(() => {
      this.element.remove()

      // Focus on next or previous task after removal
      if (taskToFocus) {
        const input = taskToFocus.querySelector('input[type="text"]')
        if (input) {
          input.focus()
          input.setSelectionRange(input.value.length, input.value.length)
        }
      }
    }, 300)

    // Update status to cancelled
    this.updateStatus("cancelled")
  }

  focusNext(event) {
    event.preventDefault()
    this.focusTask(this.getNextTask())
  }

  focusPrevious(event) {
    event.preventDefault()
    this.focusTask(this.getPreviousTask())
  }

  getNextTask() {
    // Try next sibling first
    let nextTask = this.element.nextElementSibling
    if (nextTask) return nextTask

    // If no next sibling, find all tasks across all status sections
    const allTasks = Array.from(document.querySelectorAll(".task-item"))
    const currentIndex = allTasks.indexOf(this.element)

    // Return next task in the list, or wrap to first task
    return allTasks[currentIndex + 1] || allTasks[0]
  }

  getPreviousTask() {
    // Try previous sibling first
    let prevTask = this.element.previousElementSibling
    if (prevTask) return prevTask

    // If no previous sibling, find all tasks across all status sections
    const allTasks = Array.from(document.querySelectorAll(".task-item"))
    const currentIndex = allTasks.indexOf(this.element)

    // Return previous task in the list, or wrap to last task
    return allTasks[currentIndex - 1] || allTasks[allTasks.length - 1]
  }

  focusTask(task) {
    if (task) {
      const input = task.querySelector('input[type="text"]')
      if (input) {
        input.focus()
        input.setSelectionRange(input.value.length, input.value.length)
      }
    }
  }

  expand(event) {
    event.preventDefault()

    const modal = document.getElementById("edit_task_modal")

    modal.src = this.editUrlValue
  }

  get currentStatus() {
    return this.statusFieldTarget.value
  }
}
